/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Months_MayInputs */

const es_months_may = /** @type {(inputs: Months_MayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mayo`)
};

const en_months_may = /** @type {(inputs: Months_MayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`May`)
};

/**
* | output |
* | --- |
* | "May" |
*
* @param {Months_MayInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const months_may = /** @type {((inputs?: Months_MayInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Months_MayInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_months_may(inputs)
	return en_months_may(inputs)
});
export { months_may as "months.may" }